<header id="top">
  <a [routerLink]="'/'" id="app-logo"><img alt="AIM by Kochava" id="svg-logo" src="/assets/images/logo.svg" /></a>
  <div *ngIf="showEnvironment" class="environment">ENV: {{environmentName}}</div>
  <app-identity></app-identity>
</header>
